import Modal from 'react-modal';
import { IPixAccountViewModel } from 'viewModels';
import { ContentModal, Header } from './style';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { BasicButton } from '../..';
import { PixType, labelPixType } from '../../../types/enums';

interface ModalDeletePixAccountProps {
  isOpen: boolean;
  currentPixAccount: IPixAccountViewModel;
  onRequestClose: () => void;
  onRequestRemovePixAccount: () => void;
}

export default function ModalDeletePixAccount({
  isOpen,
  currentPixAccount,
  onRequestClose,
  onRequestRemovePixAccount,
}: ModalDeletePixAccountProps) {
  const handleDeletePixAccount = () => {
    onRequestRemovePixAccount();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            x
          </button>
        </div>
      </Header>
      <ContentModal>
        <h2 className="confirmationText">Deseja realmente excluir a chave pix?</h2>
        Tipo: <p>{labelPixType[currentPixAccount.type as unknown as PixType]}</p>
        Chave: <p>{currentPixAccount.key}</p>
        <div className="buttonModal">
          <BasicButton variant="outlined" size="medium" onClick={onRequestClose}>
            Cancelar
          </BasicButton>
          <BasicButton variant="outlined" size="medium" onClick={handleDeletePixAccount}>
            Excluir
          </BasicButton>
        </div>
      </ContentModal>
    </Modal>
  );
}
